import { cx } from "@nju/css";
import { Icon, IconName, IconStyleProps } from "@nju/icons";

interface IButtonProps {
  isActive: boolean;
  label: string;
  badge: string | undefined;
  icon?: {
    name: IconName;
    tone: IconStyleProps["tone"];
  };
}

export function Button({ isActive, icon, label, badge }: IButtonProps) {
  return (
    <div
      className={cx(
        "flex items-center gap-2 relative px-3 py-1 rounded-badge from-tablet:px-5 from-tablet:py-2 only-mobile:mt-[5px]",
        {
          "bg-daintree border-solid border-daintree border-2 text-white":
            isActive,
          "border-solid border-darkBlue border-1": !isActive,
          "border-brightCerulean border-dashed border-[2px]": !!icon,
        },
      )}
    >
      {icon && <Icon name={icon.name} tone={icon.tone} />}
      {label}
      {badge && (
        <span className="absolute top-0 right-3 bg-ripeLemon rounded-badge text-daintree font-bold text-size-12 px-2 py-0 translate-y-[-50%]">
          {badge}
        </span>
      )}
    </div>
  );
}
